'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");

var textInput = Curry._1(Css.style, {
      hd: Css.padding2(Css.em(0.4), Css.em(1)),
      tl: {
        hd: Css.border(Css.px(0), "none", Css.transparent),
        tl: {
          hd: Css.borderBottom(Css.px(1), "solid", Css.hex("bbb")),
          tl: {
            hd: Css.backgroundColor(Css.transparent),
            tl: {
              hd: Css.fontWeight("medium"),
              tl: {
                hd: Css.fontSize({
                      NAME: "rem",
                      VAL: 1.8
                    }),
                tl: {
                  hd: Css.width({
                        NAME: "percent",
                        VAL: 100
                      }),
                  tl: {
                    hd: Css.selector("&::placeholder", {
                          hd: Css.color(Css.gray),
                          tl: /* [] */0
                        }),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  textInput: textInput
};

function Input$Text(Props) {
  var onChange = Props.onChange;
  var value = Props.value;
  var placeholder = Props.placeholder;
  return React.createElement("input", {
              className: textInput,
              placeholder: Belt_Option.getWithDefault(placeholder, ""),
              value: value,
              onChange: onChange
            });
}

var $$Text = {
  make: Input$Text
};

function Input$Range(Props) {
  var onChange = Props.onChange;
  var value = Props.value;
  var min = Props.min;
  var max = Props.max;
  return React.createElement("input", {
              max: max,
              min: min,
              type: "range",
              value: value,
              onChange: onChange
            });
}

var $$Range = {
  make: Input$Range
};

exports.Styles = Styles;
exports.$$Text = $$Text;
exports.$$Range = $$Range;
/* textInput Not a pure module */
